var indentation_default = {
  "indentZero": "F-Dyt",
  "indentOne": "_80ys-",
  "indentTwo": "LBUT8",
  "indentThree": "nHjms",
  "indentFour": "txAyi",
  "indentFive": "Ebo3u",
  "indentSix": "zJ-BU"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
